var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mine-page"},[_c('p',[_vm._v("这是隐私条款页面")])])
}]

export { render, staticRenderFns }